import { Box, Spinner } from "@shopify/polaris"

export const PageSpinner = () => {
    return (
        <Box padding='400'>
            <Spinner size="small" />
        </Box>
    )
}